import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsPlay: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m1 0l14 8l-14 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsPlay
